import { useLocalStorage } from 'usehooks-ts';
import { useQuery } from 'react-query';

import { CONFIG_STALE_TIME } from 'coreOld/constants';
import { LocalStorageKeys } from 'coreOld/enums';
import { configsService } from 'coreOld/services';
import { getLogoPaths } from 'coreOld/utils';

export const useGetLogoPaths = () => {
  const [logoPaths, setLogoPaths] = useLocalStorage(LocalStorageKeys.LOGO_PATHS, {});

  const { isError, isLoading } = useQuery(
    ['logoPaths'],
    ({ signal }) => configsService.getLogoPaths(signal),
    {
      keepPreviousData: true,
      staleTime: CONFIG_STALE_TIME,
      onSuccess: (data) => {
        setLogoPaths(getLogoPaths(data));
      },
    }
  );

  return {
    logoPaths: logoPaths,
    logoPathsError: isError,
    logoPathsLoading: isLoading,
  };
};
